import React, { Component, Fragment } from "react";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../../modules/simpleTextArea";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import * as R from "ramda";
import { mapToObjectDDL } from "../../../../common/mapper";
import Api from "../../../../../Services/Api";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import {
  constructFormData,
  downloadPdf,
  getDefaultSelReceiver,
  hidden,
  hiddenFileImage,
  printPDF,
  resetIgnoreKeys,
  validate,
} from "../util";
import SimpleCamera from "../../../../../modules/SimpleCamera";
import SimplePrintButton from "../../../../../modules/SimplePrintButton";
import {
  contructQueryParam,
  fetchDataAsync,
} from "../../../../../Services/Utils";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import { HttpStatus } from "../../../../common/Constants";

class DetailInputModifying extends Component {
  receiverOptions = [
    { label: "Petugas", value: "PETUGAS" },
    { label: "Pemilik STNK", value: "PEMILIK_STNK" },
    { label: "Bukan Pemilik STNK", value: "BUKAN_PEMILIK_STNK" },
  ];

  constructor(props) {
    super(props);
    this.state = {
      isReceivingSalesmanSelected: false,
      alertModalSaveVisible: false,
      provinceOptions: [],
      kotaOptions: [],
      kecamatanOptions: [],
      kelurahanOptions: [],
      zipCodeOptions: [],
      data: {
        selReceiver: null,
      },
      loadingPhoto: false
    };
  }

  componentDidMount() {
    this.fetchDataProvinceOptions();
    this.fetchDataPhoto(this.props.tab)
    this.props.setValue("documentCode", this.props.dataDetail.bpkbNo);
    this.setState((prevState) => ({
      ...prevState,
      isReceivingSalesmanSelected: !R.and(
        !R.isNil(this.props.dataDetail[this.props.tab]),
        R.and(
          !R.isNil(this.props.dataDetail[this.props.tab]?.receiverName),
          !R.isEmpty(this.props.dataDetail[this.props.tab]?.receiverName)
        )
      ),
      data: {
        ...prevState.data,
        selReceiver: getDefaultSelReceiver(
          this.props.dataDetail[this.props.tab]
        ),
      },
    }));
  }

  handleSelectedReceivingSalesman = (e) => {
    const isChecked = e.target.checked;
    this.setState((prevValue) => ({
      ...prevValue,
      isReceivingSalesmanSelected: isChecked,
    }));
  };

  handleChangeProvince = async (name, value) => {
    this.props.setValue(name, value);
    if (!R.isNil(value)) {
      this.props.setValue("kabKot", null);
      this.props.setValue("kecamatan", null);
      this.props.setValue("kelurahan", null);
      this.props.setValue("zipCode", null);
      await this.fetchDataKotaOptions(value.value);
    }
  };

  handleChangeKota = async (name, value) => {
    this.props.setValue(name, value);
    if (!R.isNil(value)) {
      this.props.setValue("kecamatan", null);
      this.props.setValue("kelurahan", null);
      this.props.setValue("zipCode", null);
      await this.fetchDataKecamatanOptions(value.value);
    }
  };

  handleChangeKecamatan = async (name, value) => {
    this.props.setValue(name, value);
    if (!R.isNil(value)) {
      this.props.setValue("kelurahan", null);
      this.props.setValue("zipCode", null);
      await this.fetchDataKelurahanOptions(value.value);
    }
  };

  handleChangeKelurahan = async (name, value) => {
    this.props.setValue(name, value);
    if (!R.isNil(value)) {
      this.props.setValue("zipCode", null);
      this.setState((prevState) => ({
        ...prevState,
        zipCodeOptions: [mapToObjectDDL(value.zipCode, value.zipCode)],
      }));
    }
  };

  handleAlertModalSaveVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      alertModalSaveVisible: !prevState.alertModalSaveVisible,
    }));
  };

  handleSubmit = () => {
    const isChecked = this.state.isReceivingSalesmanSelected;
    const controls = this.props.controls;
    const tab = this.props.tab;
    const selReceiver = this.state.data.selReceiver;
    if (
      this.props.customValidate(validate(controls, isChecked, tab, selReceiver))
    ) {
      const payload = constructFormData(controls, isChecked, tab, selReceiver);
      payload.factureNo = this.props.dataDetail?.factureNo || null
      payload.kodeCabang = this.props.selectedCabang?.value || null
      resetIgnoreKeys(isChecked, selReceiver, tab, this.props);
      this.handleAlertModalSaveVisibility();
      this.props.onSubmit(payload);
    }
  };

  handleChangeReceiver = (name, value) => {
    this.setState((prevState) => ({
      ...prevState,
      data: {
        ...prevState.data,
        [name]: value,
      },
    }));
  };

  handlePrint = async () => {
    this.props.triggerLoading();
    let req = contructQueryParam({
      processBbnId: this.props.initialValues.processBbnId,
    });
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT").printBbnIndividu,
      menuName: "Detail Penyerahan BBN Pelanggan",
      setError: this.props.setError,
      args: req,
    });
    if (res.ok) {
      printPDF(res.data, this.props.namaPembeli + "_Penyerahan BPKB.pdf");
    }
    this.props.triggerLoading();
  };

  fetchDataPhoto = async (type) => {
    this.setState({ loadingPhoto: true })
    const res = await Api.create("NAGAMAS_TRANSACTION").getBBNPhotoById({
      bbnType: type,
      processBbnId: this.props.initialValues.processBbnId,
    })
    if(res.ok && res.data.status === HttpStatus.SUCCESS){
      this.props.setValue("idPhoto", res?.data?.data?.idPhoto || null)
      this.props.setValue("receiverPhoto", res?.data?.data?.receiverPhoto || null)
      this.props.setValue("suratKuasa", res?.data?.data?.suratKuasa || null)
      this.props.setValue("sidikJari", res?.data?.data?.sidikJari || null)
    }
    this.setState({ loadingPhoto: false })
  }

  fetchDataProvinceOptions = async () => {
    const res = await Api.create("NAGAMAS_MASTER_DATA").getAllProvince();
    if (res.ok && !R.isEmpty(res.data.data)) {
      if (res.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          provinceOptions: res.data.data.map((item) =>
            mapToObjectDDL(item.provinceName, item.id)
          ),
        }));
      }
    }
  };

  fetchDataKotaOptions = async (id) => {
    const response = await Api.create("NAGAMAS_MASTER_DATA").getAllCity(id);
    if (response.ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        kotaOptions: response.data.data.map((option) =>
          mapToObjectDDL(option.kabKotName, option.kabKotId)
        ),
      }));
    }
  };

  fetchDataKecamatanOptions = async (id) => {
    const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan(
      id
    );
    if (response.ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        kecamatanOptions: response.data.data.map((option) =>
          mapToObjectDDL(option.kecamatanName, option.id)
        ),
      }));
    }
  };

  fetchDataKelurahanOptions = async (id) => {
    const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan(
      id
    );
    if (response.ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        kelurahanOptions: response.data.data.map((option) => ({
          ...mapToObjectDDL(option.kelurahanname, option.id),
          zipCode: option.zipcode,
        })),
      }));
    }
  };

  render() {
    console.log(this.props,'props')
    return (
      <Fragment>
        {!R.equals(this.props.tab, "BPKB") ? (
          <div style={{ marginTop: "20px", marginBottom: "20px" }}>
            <SimpleCheckBox
              id="input_check_box_penerima_salesman"
              key="isReceivingSalesmanSelected"
              name="isReceivingSalesmanSelected"
              label="Penerima adalah Salesman / Penjual"
              checked={this.state.isReceivingSalesmanSelected}
              onChange={(e) => this.handleSelectedReceivingSalesman(e)}
            />
          </div>
        ) : (
          <div className="grid grid-2x gap-20px grid-mobile-none">
            <div id="grid-1">
              <SimpleDDL
                id="select_options_province"
                name="selReceiver"
                label="Penerima"
                box="search"
                mandatory
                isClearable
                errorMessage={this.props.errors.selReceiver}
                options={this.receiverOptions}
                value={this.state.data?.selReceiver}
                onChange={(value, { name }) =>
                  this.handleChangeReceiver(name, value)
                }
              />
            </div>
            <div id="grid-2"></div>
          </div>
        )}

        {hidden(
          this.state.isReceivingSalesmanSelected,
          this.state.data.selReceiver,
          this.props.tab
        ) && (
          <>
            <div className="grid grid-2x gap-20px grid-mobile-none">
              <div id="grid-1">
                <SimpleInput
                  id="input_text_receiving_name"
                  name="receiverName"
                  label="Nama Penerima"
                  mandatory
                  errorMessage={this.props.errors.receiverName}
                  value={this.props.controls.receiverName?.value}
                  onChange={({ target }) =>
                    this.props.setValue(target.name, target.value)
                  }
                />
                <SimpleInput
                  id="input_text_nik"
                  name="nik"
                  label="NIK"
                  box="onlyNumber"
                  value={this.props.controls.nik?.value}
                  onChange={({ target }) =>
                    this.props.setValue(target.name, target.value)
                  }
                />
                <SimpleInput
                  id="input_text_no_wa"
                  name="noWa"
                  label="No WA"
                  box="onlyNumber"
                  mandatory
                  errorMessage={this.props.errors.noWa}
                  value={this.props.controls.noWa?.value}
                  onChange={({ target }) =>
                    this.props.setValue(target.name, target.value)
                  }
                />
                <SimpleInput
                  id="input_text_no_hp"
                  name="noHp"
                  label="No HP"
                  box="onlyNumber"
                  mandatory
                  errorMessage={this.props.errors.noHp}
                  value={this.props.controls.noHp?.value}
                  onChange={({ target }) =>
                    this.props.setValue(target.name, target.value)
                  }
                />
                <SimpleTextArea
                  id="input_text_address"
                  name="address"
                  label="Alamat"
                  mandatory
                  errorMessage={this.props.errors.address}
                  value={this.props.controls.address?.value}
                  onChange={({ target }) =>
                    this.props.setValue(target.name, target.value)
                  }
                />
              </div>
              <div id="grid-2">
                {R.equals(this.props.tab, "BPKB") && (
                  <SimpleInput
                    id="input_text_no_document"
                    name="documentCode"
                    label="Nomor Dokumen"
                    readOnly
                    value={this.props.controls.documentCode?.value}
                    onChange={({ target }) =>
                      this.props.setValue(target.name, target.value)
                    }
                  />
                )}
                <SimpleDDL
                  id="select_options_province"
                  name="province"
                  label="Provinsi"
                  box="search"
                  mandatory
                  errorMessage={this.props.errors.province}
                  isClearable
                  options={this.state.provinceOptions}
                  value={this.props.controls.province?.value}
                  onChange={(value, { name }) =>
                    this.handleChangeProvince(name, value)
                  }
                />
                <SimpleDDL
                  id="select_options_city"
                  name="kabKot"
                  label="Kota"
                  box="search"
                  mandatory
                  errorMessage={this.props.errors.kabKot}
                  options={this.state.kotaOptions}
                  value={this.props.controls.kabKot?.value}
                  onChange={(value, { name }) =>
                    this.handleChangeKota(name, value)
                  }
                />
                <SimpleDDL
                  id="select_options_district"
                  name="kecamatan"
                  label="Kecamatan"
                  box="search"
                  mandatory
                  errorMessage={this.props.errors.kecamatan}
                  options={this.state.kecamatanOptions}
                  value={this.props.controls.kecamatan?.value}
                  onChange={(value, { name }) =>
                    this.handleChangeKecamatan(name, value)
                  }
                />
                <SimpleDDL
                  id="select_options_subdistrict"
                  name="kelurahan"
                  label="Kelurahan"
                  box="search"
                  mandatory
                  errorMessage={this.props.errors.kelurahan}
                  options={this.state.kelurahanOptions}
                  value={this.props.controls.kelurahan?.value}
                  onChange={(value, { name }) =>
                    this.handleChangeKelurahan(name, value)
                  }
                />
                <SimpleDDL
                  id="select_options_zipCode"
                  name="zipCode"
                  label="Kode Pos"
                  box="search"
                  mandatory
                  errorMessage={this.props.errors.zipCode}
                  options={this.state.zipCodeOptions}
                  value={this.props.controls.zipCode?.value}
                  onChange={(value, { name }) =>
                    this.props.setValue(name, value)
                  }
                />
              </div>
            </div>
          </>
        )}

        {hiddenFileImage(this.state.data.selReceiver, this.props.tab) && (
          <>
            <div className="grid grid-2x gap-20px grid-mobile-none">
              <div id="grid-1">
                <SimpleCamera
                  loading={this.state.loadingPhoto}
                  id="input_upload_foto_ktp"
                  name="idPhoto"
                  label="KTP Penerima"
                  mandatory
                  errorMessage={this.props.errors.idPhoto}
                  value={this.props.controls.idPhoto?.value}
                  onChange={(value, name) => this.props.setValue(name, value)}
                />
              </div>
              <div id="grid-2">
                <SimpleCamera
                  loading={this.state.loadingPhoto}
                  id="input_upload_foto_penerima"
                  name="receiverPhoto"
                  label="Penerima"
                  mandatory
                  errorMessage={this.props.errors.receiverPhoto}
                  value={this.props.controls.receiverPhoto?.value}
                  onChange={(value, name) => this.props.setValue(name, value)}
                />
              </div>
            </div>
            {R.equals(this.props.tab, "BPKB") && (
              <div className="grid grid-2x gap-20px grid-mobile-none">
                <div id="grid-1">
                  {!R.equals(
                    this.state.data.selReceiver?.value,
                    "PEMILIK_STNK"
                  ) ? (
                    <SimpleCamera
                      loading={this.state.loadingPhoto}
                      id="input_upload_foto_surat_kuasa"
                      name="suratKuasa"
                      label="Surat Kuasa"
                      mandatory
                      errorMessage={this.props.errors.suratKuasa}
                      value={this.props.controls.suratKuasa?.value}
                      onChange={(value, name) =>
                        this.props.setValue(name, value)
                      }
                    />
                  ) : (
                    <SimpleCamera
                      loading={this.state.loadingPhoto}
                      id="input_upload_foto_sidik_jari"
                      name="sidikJari"
                      label="Sidik Jari"
                      mandatory
                      errorMessage={this.props.errors.sidikJari}
                      value={this.props.controls.sidikJari?.value}
                      onChange={(value, name) =>
                        this.props.setValue(name, value)
                      }
                    />
                  )}
                </div>
                <div id="grid-2">
                  {!R.equals(
                    this.state.data.selReceiver?.value,
                    "PEMILIK_STNK"
                  ) && (
                    <SimpleCamera
                      loading={this.state.loadingPhoto}
                      id="input_upload_foto_sidik_jari"
                      name="sidikJari"
                      label="Sidik Jari"
                      mandatory
                      errorMessage={this.props.errors.sidikJari}
                      value={this.props.controls.sidikJari?.value}
                      onChange={(value, name) =>
                        this.props.setValue(name, value)
                      }
                    />
                  )}
                </div>
              </div>
            )}
          </>
        )}

        <div className="grid grid-2x gap-20px grid-mobile-none">
          <div id="grid-1">
            <SimpleInput
              id="input_text_officer_name"
              name="staffId"
              label="Nama Petugas"
              readOnly
              value={this.props.controls.staffId?.value?.label}
              onChange={({ target }) =>
                this.props.setValue(target.name, target.value)
              }
            />
            <SimpleInput
              id="input_text_date"
              name="date"
              label="Tanggal"
              readOnly
              value={this.props.controls.date?.value}
              onChange={({ target }) =>
                this.props.setValue(target.name, target.value)
              }
            />
            <SimpleInput
              id="input_text_time"
              name="time"
              label="Waktu"
              readOnly
              value={this.props.controls.time?.value}
              onChange={({ target }) =>
                this.props.setValue(target.name, target.value)
              }
            />
          </div>
        </div>

        <div style={{ textAlign: "right", marginTop: "20px" }}>
          <FlexView hAlignContent={"right"}>
            {R.equals(this.props.tab, "BPKB") && (
              <SimpleButton
                type="button"
                styles={{
                  width:"220px"
                }}
                text="Cetak Bukti Serah Terima BPKB"
                onClick={() => this.handlePrint()}
              />
              // <SimplePrintButton
              //     styles={{width: "220px"}}
              //     text="Cetak Bukti Serah Terima BPKB"
              //     toPdf
              //     toExcel
              //     onPrint={(value) => alert("This function is under development")}
              // />
            )}
            <SimpleButton
              type="button"
              text="Simpan"
              // onClick={() => this.handleSubmit()}
              onClick={() => this.handleAlertModalSaveVisibility()}
            />
          </FlexView>
        </div>

        {this.state.alertModalSaveVisible && (
          <SimpleAlert
            title={"Information"}
            content={
              <p>Proses Penyerahan BBN Membutuhkan <b>Approval</b>. Apakah anda yakin ?</p>
            }
            visible={this.state.alertModalSaveVisible}
            onClickClose={this.handleAlertModalSaveVisibility}
            additionalButtons={
              <FlexView>
                <SimpleButton
                  secondary
                  type="button"
                  text="Batal"
                  onClick={() => this.handleAlertModalSaveVisibility()}
                />
                <SimpleButton
                  type="button"
                  text="OK"
                  onClick={() => this.handleSubmit()}
                />
              </FlexView>
            }
          />
        )}
      </Fragment>
    );
  }
}

export default withFormGroup(DetailInputModifying);
